var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.809,
    height: 92.806,
    viewBox: "0 0 92.809 92.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(-4147.5 2859.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M80.18,92.806a46.4,46.4,0,1,1,46.4-46.4,46.458,46.458,0,0,1-46.4,46.4m0-83.7a37.3,37.3,0,1,0,37.3,37.3A37.342,37.342,0,0,0,80.18,9.1",
    transform: "translate(4113.724 -2859.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M60.867,24.309H48.2a1.462,1.462,0,1,1,0-2.923H60.867a1.462,1.462,0,0,1,0,2.923",
    transform: "translate(4139.656 -2816.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M56.971,25.924H49.054a1.462,1.462,0,1,1,0-2.923h7.917a1.462,1.462,0,0,1,0,2.923",
    transform: "translate(4141.36 -2813.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M68.047,48.8H54.583a1.1,1.1,0,0,1-1.1-1.1,13.418,13.418,0,0,0-4.334-9.859,18,18,0,1,1,24.325,0A13.5,13.5,0,0,0,69.148,47.7a1.1,1.1,0,0,1-1.1,1.1m-12.4-2.2H66.984a15.738,15.738,0,0,1,5-10.378,15.8,15.8,0,1,0-21.344-.006A15.641,15.641,0,0,1,55.646,46.6",
    transform: "translate(4132.812 -2845.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M52.55,11.547a9.367,9.367,0,0,0-3.637,12.7,1.272,1.272,0,0,1-.5,1.726,1.221,1.221,0,0,1-.6.147,1.262,1.262,0,0,1-1.1-.645A11.873,11.873,0,0,1,51.322,9.344a1.261,1.261,0,1,1,1.227,2.2",
    transform: "translate(4136.622 -2840.786)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.8b134b2618f6f06ff0efff39a2cce14e.svg";
export { ForwardRef as ReactComponent };